import { render, staticRenderFns } from "./BonusItemsTable.vue?vue&type=template&id=5fa1d22c&scoped=true"
import script from "./BonusItemsTable.vue?vue&type=script&lang=js"
export * from "./BonusItemsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa1d22c",
  null
  
)

export default component.exports